var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-row-container"},[_c('el-button',{staticClass:"add-row",attrs:{"icon":"el-icon-plus","size":"mini","type":"success","circle":""},on:{"click":function($event){return _vm.$emit('addRow')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }